"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _test = babelHelpers.interopRequireDefault(require("./test"));

var Challenge =
/*#__PURE__*/
function (_Test) {
  babelHelpers.inherits(Challenge, _Test);

  function Challenge() {
    babelHelpers.classCallCheck(this, Challenge);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Challenge).apply(this, arguments));
  }

  return Challenge;
}(_test.default);

exports.default = Challenge;
;